import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  ConsumerReviewsEntities,
  ConsumerReviewsModel,
  ConsumerReviewsPaths,
} from 'client/data/models/consumer-reviews';
import { useStateCallback } from 'site-modules/shared/hooks/use-state-callback';
import { Select } from 'site-modules/shared/components/select/select';
import { FormField } from 'site-modules/shared/components/form-field/form-field';
import {
  FIELD_DANGER_CLASS_NAMES,
  FORM_FIELD_CLASS_NAMES,
  FORM_FIELD_NAMES,
} from 'site-modules/shared/constants/write-review/write-review';

function VehicleDetailsUI({ reviewData = null, types = {}, fieldRef, validate, validationErrors = {} }) {
  const typeName = get(reviewData, 'bodyType.submodelName');
  const styleId = get(reviewData, 'styleId');
  const [type, setType] = useStateCallback(typeName ? { name: typeName } : null);
  const [model, setModel] = useStateCallback(styleId ? { styleId } : null);

  const onTypeChange = useCallback(newType => {
    setType(newType, () => validate(null, FORM_FIELD_NAMES.BODY_TYPE));
    setModel(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onModelChange = useCallback(newModel => {
    setModel(newModel, () => validate(null, FORM_FIELD_NAMES.STYLE_ID));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { BODY_TYPE, STYLE_ID } = FORM_FIELD_NAMES;

  const typeOptions = Object.keys(types).map(styleType => ({ name: styleType }));
  const modelOptions = type && types[type.name];

  return (
    <Row className="vehicle-details">
      <Col xs={12} md={6}>
        <div className="heading-4 mb-1_5">Vehicle details</div>
        <FormField
          {...FORM_FIELD_CLASS_NAMES}
          inputClassName="size-16 px-0_5"
          tag={Select}
          value={type && type.name}
          options={typeOptions}
          onChange={onTypeChange}
          toggle="Select a type"
          valueKey="name"
          labelKey="name"
          ref={fieldRef}
          name={BODY_TYPE}
          id={BODY_TYPE}
          label="Type"
          onBlur={validate}
          isValid={!(BODY_TYPE in validationErrors)}
        />
        <div className={FIELD_DANGER_CLASS_NAMES}>{validationErrors[BODY_TYPE]}</div>

        <FormField
          {...FORM_FIELD_CLASS_NAMES}
          inputClassName="size-16 px-0_5"
          tag={Select}
          value={model && model.styleId.toString()}
          options={modelOptions || []}
          onChange={onModelChange}
          toggle="Select a trim"
          disabled={!type}
          valueKey="styleId"
          labelKey="styleName"
          ref={fieldRef}
          name={STYLE_ID}
          id={STYLE_ID}
          label="Model"
          onBlur={validate}
          isValid={!(STYLE_ID in validationErrors)}
        />
        <div className={FIELD_DANGER_CLASS_NAMES}>{validationErrors[STYLE_ID]}</div>
      </Col>
    </Row>
  );
}

VehicleDetailsUI.propTypes = {
  fieldRef: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  types: ConsumerReviewsEntities.Styles,
  validationErrors: PropTypes.shape({}),
  reviewData: ConsumerReviewsEntities.ReviewData,
};

export const VehicleDetails = connectToModel(VehicleDetailsUI, {
  types: bindToPath(ConsumerReviewsPaths.getStylesPath(true), ConsumerReviewsModel),
});
